// extracted by mini-css-extract-plugin
module.exports = {"secondQuestion":"_1dKl3s87","title":"_1vz7CtCk"};